import { gql } from '@apollo/client';

export const ALL_CURRICULUM_TAGS_QUERY = gql`
    query curriculums {
        curriculums(useSegmentationFilter: false) {
            edges {
                node {
                    id
                    tags
                }
            }
        }
    }
`;
